package diana.soleil.design.iraniancanadienbazzar.core.model

import kotlin.time.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

/**
 * The (1-based month, year) of an account-creation epoch — the pieces of a localized "member since"
 * label. Computed in UTC (Kotlin/JS has no IANA tz database; a month/year boundary is close enough
 * for a "member since Aug 2023" line — see [canadianOffsetMinutes] for the tz-sensitive cases).
 */
data class MonthYear(val month: Int, val year: Int)

/** Splits an epoch-millis instant into its UTC (month, year); null passes through as null. */
fun memberSinceMonthYear(epochMillis: Long?): MonthYear? {
    if (epochMillis == null) return null
    val dt = Instant.fromEpochMilliseconds(epochMillis).toLocalDateTime(TimeZone.UTC)
    return MonthYear(month = dt.month.ordinal + 1, year = dt.year)
}
